// @ts-check

/**
 * @callback AccountModes.ModeFn
 * @param {import('types/api').ProviderAccountFromAPI} providerAccount
 * @return boolean
 */

/**
 * @typedef {{ [key: string]: AccountModes.ModeFn }} AccountModes
 */

// 'REFRESH' | 'ERROR' | 'EDIT' | 'MFA' | 'REFRESHING' | 'RECENT_REFRESH' | 'UNKNOWN';
//
// The various modes for the NextAction button.
// These do need to be declared in order where order is important.
export default {
  /**
   * @param {import('../../../types/api').ProviderAccountFromAPI} providerAccount
   * @return {boolean}
   */
  REFRESHING: function(providerAccount) {
    return providerAccount.refreshInfo
      && providerAccount.refreshInfo.status == 'IN_PROGRESS';
  },

  /**
   * @param {import('../../../types/api').ProviderAccountFromAPI} providerAccount
   * @return {boolean}
   */
  RECENT_REFRESH: function(providerAccount) {
    return providerAccount.refreshInfo
      && providerAccount.refreshInfo.status == 'SUCCESS'
      && providerAccount.refreshEligibility
      && providerAccount.refreshEligibility.status == 'DISALLOWED'
      && providerAccount.refreshEligibility.reasonCode == 'RECENT_REFRESH';
  },

  /**
   * @param {import('../../../types/api').ProviderAccountFromAPI} providerAccount
   * @return {boolean}
   */
  EDIT: function(providerAccount) {
    return providerAccount.refreshInfo
      && providerAccount.refreshInfo.status == 'FAILURE'
      && providerAccount.refreshInfo.additionalStatus == 'CREDENTIALS_ERROR';
  },

  /**
   * @param {import('../../../types/api').ProviderAccountFromAPI} providerAccount
   * @return {boolean}
   */
  MFA: function(providerAccount) {
    return providerAccount.refreshEligibility
      && providerAccount.refreshEligibility.status == 'ALLOWED'
      && providerAccount.refreshEligibility.reasonCode == 'WITH_CREDENTIALS';
  },

  /**
   * @param {import('../../../types/api').ProviderAccountFromAPI} providerAccount
   * @return {boolean}
   */
  ERROR: function(providerAccount) {
    return providerAccount.refreshInfo
      && providerAccount.refreshInfo.status == 'FAILURE';
  },

  /**
   * @param {import('../../../types/api').ProviderAccountFromAPI} providerAccount
   * @return {boolean}
   */
  REFRESH: function(providerAccount) {
    return providerAccount.refreshEligibility
      && providerAccount.refreshEligibility.status == 'ALLOWED'
      && !providerAccount.refreshEligibility.reasonCode;
  },
};



